import { render, staticRenderFns } from "./chartDTC.vue?vue&type=template&id=0634b3fa&"
import script from "./chartDTC.vue?vue&type=script&lang=js&"
export * from "./chartDTC.vue?vue&type=script&lang=js&"
import style0 from "./chartDTC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports